import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from "vue-router";
import Login from "@/components/login.vue";
import Layout from "@/layout/index.vue";

const router = createRouter({
  routes: [
    {
      path: "/login",
      name: "登录",
      component: Login,
    },
    {
      path: "/",
      component: Layout,
      children: [
        {
          path: "",
          name: "首页",
          component: () => import("@/components/home/indexdata.vue"),
        },
        {
          path: "order-detail",
          name: "工单详情",
          component: () => import("@/components/orderDetail.vue"),
        },
      ],
    },
  ],
  history: createWebHashHistory(),
});
export default router;
